import React from 'react';
import { utils } from '@deeptrue-frontend/ui';
import showdown from 'showdown';
import SurveyCreatorConfig from './EditorConfig/SurveyCreatorConfig';
import { customQuestionNames } from './EditorConfig/customQuestionNames';
import 'survey-core/defaultV2.min.css';
import 'survey-creator-core/survey-creator-core.min.css';

import 'survey-core/survey.i18n';

import {
  SurveyCreatorComponent,
  SurveyCreator as SurveyJSCreator,
} from 'survey-creator-react';
import registerTranslatableInput from 'components/SurveyCreator/EditorConfig/TranslatableInput/TranslatableInput';
import registerBrandSelector from 'components/SurveyCreator/EditorConfig/BrandSelector/BrandSelector';
import { registerHtmlnew } from 'components/SurveyCreator/EditorConfig/HtmlV2/HtmlV2';
import { registerAssetUpload } from 'components/SurveyCreator/EditorConfig/AssetUpload/AssetUpload';
import { registerAssetConsumer } from 'components/SurveyCreator/EditorConfig/AssetConsumer/AssetConsumer';

registerTranslatableInput();
registerBrandSelector();
registerHtmlnew();
registerAssetUpload();
registerAssetConsumer();
SurveyCreatorConfig();

interface SurveyCreatorProps {
  initialValues: {
    json: {
      [k: string]: any;
    };
  };
  templateData: any;
}

const creatorOptions = {
  showLogicTab: true,
  isAutoSave: true,
  haveCommercialLicense: true,
  showEmbededSurveyTab: true,
  showTranslationTab: true,
};

export function SurveyCreator({
  initialValues,
  templateData,
}: SurveyCreatorProps) {
  const creator = new SurveyJSCreator(creatorOptions);

  if (initialValues) {
    creator.JSON = initialValues.json;
  }

  creator.saveSurveyFunc = (saveNo: any, callback: any) => {
    const isLocalStorageData = !!window.localStorage.getItem(templateData.type);

    if (isLocalStorageData) {
      const localStorageData = JSON.parse(
        // @ts-ignore
        window.localStorage.getItem(templateData.type)
      );

      localStorageData['json'] = creator.JSON;
      window.localStorage.setItem(
        templateData.type,
        JSON.stringify(localStorageData)
      );
    } else {
      window.localStorage.setItem(
        templateData.type,
        JSON.stringify({ json: creator.JSON })
      );
    }

    callback(saveNo, true);
  };

  // TO-DO check if it's needed
  // creator.onTranslationLocaleInitiallySelected.add((_sender, options) => {
  //   options.isSelected = false; //unselect all by default.
  // });
  // TO-DO check if it works

  creator.onQuestionAdded.add(customQuestionNames);

  creator.toolbox.removeItem('reportCategories');
  creator.toolbox.removeItem('reportRecommendations');
  creator.toolbox.removeItem('sentiment');
  creator.toolbox.removeItem('sentimentEditor');

  creator.onTestSurveyCreated.add(function (sender: any, options: any) {
    const converter = new showdown.Converter();

    options.survey.onAfterRenderQuestion.add(utils.survey.widgets.Info);
    options.survey.onAfterRenderQuestion.add(utils.survey.widgets.Tooltip);
    // Remove custom classes as it affects styles
    //options.survey.css = classes;

    options.survey.onTextMarkdown.add(function (survey: any, options: any) {
      // EXPLANATION: Surveyjs do not support markdown for mobile version of matrix, because its rendering Col value as css content attribute which by default not support any of markdown. Solution is to remove <br/> tag from Col text to prevent displaying it as an answer in mobile version of matrix componennt.
      const isMobileView = window.innerWidth <= 600;
      const isQuestionMatrix =
        options.element.constructor.name === 'QuestionMatrix' ||
        options.element.constructor.name === 'QuestionMatrixModel';

      if (isQuestionMatrix && options.text.includes('<br/>')) {
        if (isMobileView) {
          const newText = options.text.replace('<br/>', '');

          options.text = newText;
          options.html = newText;
          return;
        }
      }
      //convert the mardown text to html
      let str = converter.makeHtml(options.text);
      //remove root paragraphs <p></p>
      // INFO ul list in markdown are not wrapped into <p>
      if (str.substring(0, 3).includes('ul')) {
        options.html = str;
        return;
      }
      str = str.substring(3);
      str = str.substring(0, str.length - 4);
      // //set html
      options.html = str;
    });
  });

  return <SurveyCreatorComponent creator={creator} />;
}

export default React.memo(SurveyCreator);
